import { Reveal, Overline } from "./Primitives";
import { ArrowUpRight } from "lucide-react";

export const NotSure = () => {
  const scrollToQuote = () =>
    document.querySelector("#quote")?.scrollIntoView({ behavior: "smooth" });

  return (
    <section className="bg-[#050505] py-16 md:py-20">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <Reveal>
          <div className="relative overflow-hidden border border-gold/25 bg-gradient-to-br from-[#151208] to-[#0a0a0a] p-8 md:p-12 flex flex-col lg:flex-row lg:items-center justify-between gap-8 pt-grain">
            <div className="relative z-10 max-w-2xl">
              <Overline className="mb-3">Not Sure Which Service Is Right for You?</Overline>
              <h2 className="font-display font-light text-3xl md:text-4xl text-white leading-tight">
                Let Perfect Touch help you find the <span className="gold-gradient italic">right fit</span>
              </h2>
              <p className="mt-4 text-sm md:text-base text-zinc-400 leading-relaxed">
                Every home and property is different. Tell us a little about your space, its current condition
                and what you'd like accomplished—our team will recommend the most suitable service and level of
                care. No guesswork. No unnecessary services. Just a personalized cleaning solution designed for
                your space.
              </p>
            </div>
            <button
              data-testid="notsure-cta"
              onClick={scrollToQuote}
              className="group relative z-10 shrink-0 inline-flex items-center gap-2 bg-gold text-black font-semibold px-7 py-4 hover:bg-[#c5a059] transition-colors duration-300"
            >
              Tell Us About Your Space
              <ArrowUpRight size={18} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
